import { render, staticRenderFns } from "./Pepper.vue?vue&type=template&id=020b8b01&"
import script from "./Pepper.vue?vue&type=script&lang=js&"
export * from "./Pepper.vue?vue&type=script&lang=js&"
import style0 from "./Pepper.vue?vue&type=style&index=0&id=020b8b01&prod&lang=css&"
import style1 from "./Pepper.vue?vue&type=style&index=1&id=020b8b01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports